import syncPersonalFields from './syncPersonalFields';
import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const peopleReducer = (state = initialState.people, action) => {
  switch (action.type) {
    case types.SYNC_PERSONAL_FIELDS:
      return syncPersonalFields(state, action.person, 'id');
    case types.LOAD_PEOPLE_SUCCESS:
      return action.people;
    case types.CREATE_PERSON_SUCCESS:
      return [...state, { ...action.person }];
    case types.UPDATE_PERSON_SUCCESS:
      return state.map(person => (person.id === action.person.id ? action.person : person));
    default:
      return state;
  }
};

export default peopleReducer;
